import { GmapsTravelMode } from './gmaps-travel-mode.model';
import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { LocationSearchInputComponent } from '../location-search-input/location-search-input.component';
import { LocaleAwareBaseComponent } from './../../seo/locale-aware-base.component';

@Component({
  selector: 'app-gmaps-interface',
  templateUrl: './gmaps-interface.component.html',
  styleUrls: ['./gmaps-interface.component.scss']
})

export class GmapsInterfaceComponent extends LocaleAwareBaseComponent {
  @Input() travelModes: GmapsTravelMode[];
  @Input() isInfoHidden: boolean;
  @Input() activeMode: string = 'drive';
  @Output() travelModeChanged: EventEmitter<string> = new EventEmitter<string>();
  @ViewChild(LocationSearchInputComponent) locationSearchInput: LocationSearchInputComponent;

  public changeTravelMode(mode: GmapsTravelMode): void {
    if (mode.travelMode !== this.activeMode) {
      this.isInfoHidden = true;
      this.activeMode = mode.travelMode;
      this.travelModeChanged.next(mode.travelMode);
    }
  }

  constructor() {
    super();
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/gmaps/gmaps-interface/gmaps-interface.component.ts